import { render } from "./vendor.details.vue?vue&type=template&id=dc24b94a"
import script from "./vendor.details.vue?vue&type=script&lang=js"
export * from "./vendor.details.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__